import { PostHogProvider } from '@ninjacart/nc-events-sdk-v2';
import {
  CustomToast,
  TamaguiProvider,
  type TamaguiProviderProps,
  ToastProvider,
  ToastViewport,
  config,
} from '@ninjacart/nc-nk-ui';
import { useThemeSetting } from '@tamagui/next-theme';
import { useColorScheme } from 'react-native';
// import { PwaProvider } from './pwaProvider';
import { FF4JProvider } from '@ninjacart/nc-nk-ff4j';
import { ff4jClient, GlobalInterstitialTrigger } from '@ninjacart/nc-nk-web-deps';
import { useEffect } from 'react';
import { PwaProvider } from './pwaProvider';
import { GlobalLoginContextProvide } from '@ninjacart/nc-nk-store';
import { GlobalLoginSheet } from '../features/sheets/loginBottomSheet';

export function Provider({ children, ...rest }: Omit<TamaguiProviderProps, 'config'>) {
  const themeSetting = useThemeSetting();

  useEffect(() => {
    themeSetting.set(themeSetting.systemTheme === 'dark' ? 'dark' : 'light');
  }, [themeSetting]);

  return (
    <TamaguiProvider config={config} defaultTheme={themeSetting.current || 'light'} {...rest}>
      {/* <PostHogProvider client={posthog}> */}
      <PostHogProvider>
        <ToastProvider swipeDirection="horizontal" duration={6000}>
          {/* <PwaProvider> */}
          <PwaProvider>
            <CustomToast />
            <ToastViewport />
            {/* <ReportFastContextProvider>
            <GlobalLoginContextProvide>
              <FF4JProvider client={ff4jClient}>{children}</FF4JProvider>
              <GlobalLoginSheet />
              <GlobalReportBottomSheetComponent />
            </GlobalLoginContextProvide>
          </ReportFastContextProvider> */}
          </PwaProvider>
          {/* </PwaProvider> */}
          <GlobalLoginContextProvide>
            <FF4JProvider client={ff4jClient}>{children}</FF4JProvider>
            <GlobalLoginSheet />
            <GlobalInterstitialTrigger />
          </GlobalLoginContextProvide>
        </ToastProvider>
      </PostHogProvider>
    </TamaguiProvider>
  );
}
